var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M19.25 16.5C19.2457 17.2047 18.6914 17.875 17.8707 17.875H1.37846C0.558614 17.875 0.00388685 17.2047 1.96664e-05 16.5C-0.00185764 16.1529 0.130732 15.8186 0.369981 15.5671C1.20014 14.6751 2.75346 13.3328 2.75346 8.9375C2.75346 5.59883 5.09439 2.92617 8.25088 2.27047V1.375C8.25088 1.01033 8.39574 0.660591 8.65361 0.402728C8.91147 0.144866 9.26121 0 9.62588 0C9.99055 0 10.3403 0.144866 10.5982 0.402728C10.856 0.660591 11.0009 1.01033 11.0009 1.375V2.27047C14.1548 2.92617 16.4957 5.59883 16.4957 8.9375C16.4957 13.3332 18.049 14.6751 18.8792 15.5671C19.1187 15.8185 19.2516 16.1528 19.25 16.5V16.5Z",
    fill: "#335C75"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.87506 19.25H12.3751C12.3751 19.9793 12.0853 20.6788 11.5696 21.1945C11.0539 21.7103 10.3544 22 9.62506 22C8.89572 22 8.19624 21.7103 7.68052 21.1945C7.16479 20.6788 6.87506 19.9793 6.87506 19.25Z",
    fill: "#335C75"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/Bell.5669d48d.svg";
export { ForwardRef as ReactComponent };